import { AppState } from '../rootReducer';

export const getHelpersModeState = (state: AppState): boolean => state.helpersMode.isHelpersModeEnabled;
